export const getInstanceIdFromDocumentDomElement = (element) => element?.dataset?.instanceId;

export const searchForVariationElement = (domElement) => {
  if (domElement == null) {
    return null;
  }
  if (domElement.dataset?.variation != null) {
    return domElement;
  }

  return searchForVariationElement(domElement.parentElement);
};
